import React, { useState, useEffect, useCallback } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../utils/firebase';
import { Outlet, useOutlet, useNavigate } from "react-router-dom"
import { fetchUserData, fetchMenuByID } from '../../utils/database';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';


export default function AppLayout() {
    const [userAuth, setUserAuth] = useState(undefined)
    const [userData, setUserData] = useState(undefined)
    const [userMenu, setUserMenu] = useState(undefined)

    const outlet = useOutlet()
    const navigate = useNavigate()

    const updateUserMenu = useCallback(async () => {
        setUserMenu(await fetchMenuByID(userData.menuid))
    }, [userData])

    const updateUserData = useCallback(async () => {
        setUserData(await fetchUserData(userAuth.uid))
    }, [userAuth])

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                setUserAuth(user)

            } else {
                setUserAuth(false)
            }
        });

        if (outlet === null) {
            navigate("/admin/app")
        }

        return () => unsubscribe()
    }, [navigate, outlet])

    useEffect(() => {
        if (userAuth) {
            updateUserData()
        }
    }, [userAuth, updateUserData])

    useEffect(() => {
        if (userData) {
            updateUserMenu()
        }
    }, [userData, updateUserMenu])

    //render app si no hay nada mas
    //render lo que corresponda si hay mas ruta

    return <Outlet context={[userAuth, userData, userMenu, updateUserData, updateUserMenu]} />
}
